'use client';
import { useState } from 'react';

/** Decorative identity image; the enclosing control supplies its accessible name. */
export default function ProfileAvatar({ src, name, className = 'ss-app-dock-avatar', selected }: { src?: string | null; name: string; className?: string; selected?: boolean }) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  const initials = name.trim().split(/\s+/).slice(0, 2).map(part => part[0]).join('').toUpperCase() || '?';
  return <span className={className} data-selected={selected || undefined} aria-hidden="true">{src && src !== failedSrc ? <img src={src} alt="" referrerPolicy="no-referrer" onError={() => setFailedSrc(src)} /> : initials}</span>;
}
